/**
 * @author MSA
 */

export class Login {
  origin?: string;
  username?: string;
  password?: string;
}